import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import RequireAuth from "../components/RequireAuth";
import HealthPage from "../modules/health/HealthPage";
import AnnouncementPage from "../modules/announcement/AnnouncementPage";
import DashboardPage from "../modules/dashboard/DashboardPage";
import UserList from "../modules/user/UserList";
import UserDetail from "../modules/user/UserDetail";
import EditUser from "../modules/user/EditUser";
import SongRequestList from "../modules/songRequest/SongRequestList";
import SongV2List from "../modules/songV2/SongV2List";
import SongV2Detail from "../modules/songV2/SongV2Detail";
import AddSongV2 from "../modules/songV2/AddSongV2";
import EditSongV2 from "../modules/songV2/EditSongV2";
import NotificationPage from "../modules/notifications/NotificationPage";
import BeatList from "../modules/beat/BeatList";
import AddBeat from "../modules/beat/AddBeat";
import EditBeat from "../modules/beat/EditBeat";
import AddSongType from "../modules/songType/AddSongType";
import SongsterrPage from "../modules/songsterr/SongsterrPage";

import LoginPage from "../modules/login/LoginPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Korumalı alan */}
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/users/:id" element={<UserDetail />} />
        <Route path="/users/:id/edit" element={<EditUser />} />
        <Route path="/song-requests" element={<SongRequestList />} />
        <Route path="/songs" element={<SongV2List />} />
        <Route path="/songs/:id" element={<SongV2Detail />} />
        <Route path="/songs/add" element={<AddSongV2 />} />
        <Route path="/songs/edit/:id" element={<EditSongV2 />} />
        <Route path="/notifications" element={<NotificationPage />} />
        <Route path="/health" element={<HealthPage />} />
        <Route path="/announcements" element={<AnnouncementPage />} />

        {/* Legacy routes retained but hidden from active sidebar */}
        <Route path="/beats" element={<BeatList />} />
        <Route path="/beats/add" element={<AddBeat />} />
        <Route path="/beats/edit/:id" element={<EditBeat />} />
        <Route path="/song-types" element={<AddSongType />} />
        <Route path="/songsv2" element={<Navigate to="/songs" replace />} />
        <Route path="/songsv2/:id" element={<SongV2Detail />} />
        <Route path="/songsv2/add" element={<AddSongV2 />} />
        <Route path="/songsv2/edit/:id" element={<EditSongV2 />} />
        <Route path="/studio" element={<SongsterrPage />} />
        <Route path="/songsterr-parser" element={<Navigate to="/studio" replace />} />
      </Route>
    </Routes>
  );
}
